module.exports = __webpack_public_path__ + "img/harryCartoon.b78d06b2.png";